export default class Video {
    constructor() {
        // 頭部視頻彈窗
        this.videoLity()
    }

    videoLity() {
        // $('#video_mask').on('click', function () {
        //     let videoSrc = $(this).data('videoSrc')
        //     window.__lity = window.lity(videoSrc);
        // })

        let video = document.querySelector('.iphoneVideo video')
        video.controls = false;
    }
}